import React from 'react';
import './Electrical.css';
import Menu from '../../Menu/Menu';
import b8 from '../../../img/electrical2.jpg';



const Electrical = () => {
    return (
        <div className='mb-5'>
            
            <div className='about8'>
                <div className='bg'>
                    <Menu></Menu>
                    <h1 className='text-white display-5 fw-bold doris pt-lg-5 pb-5 mx-auto top'>Electrical Design & Wearing</h1>
                </div>
            </div>

            <div id="gis">
                <h2 className='heading pt-5 px-3'>Electrical Design & Wearing</h2>
                <hr className='w-50 mx-auto'></hr>
                <h5 className='px-5 mx-lg-3'>
                    <div className='row'>
                        <div className='col-lg-6 col-md-6 col-sm-12 pt-3 mb-3'>
                        One part of our company Conducted electrical design & wearing. we have
                        huge experienced about this platform. Specially many industrial work of
                        multistoried buildings we were conducted about electrical design and
                        wearing also on going project now continued. 
                            {/* <img src={b8} alt="" width="100%" className='me-2'/> */}
                        </div>
                        
                        <div className='col-lg-6 col-md-6 col-sm-12 px-lg-5'>
                            <div className='mt-3'>
                                    <img src={b8} alt="" width="100%" className='me-2 mb-3'/>
                                </div>
                        </div>
                    </div>
                </h5>
            </div>            
        </div>
    );
};

export default Electrical;